import * as React from 'react';
import { Wrapper, CtaWrapper } from './SectionProfessional.s';
import { SectionContent } from '@components/Sections/Sections.s';
import { ProfessionalCard } from '@components/ProfessionalCard/ProfessionalCard.s';
import { CardHeading, Paragraph } from '@components/Typos/Typos.s';
import { Cta } from '@components/Cta/Cta.s';
import { proPath } from '@config/paths';

export const SectionProfessional = () => (
  <Wrapper>
    <SectionContent>
      <ProfessionalCard>
        <CardHeading>
          Besoin de visibilité ?
        </CardHeading>
        <Paragraph>
          Vous êtes un musée, un centre d’exposition, un collectif, une association ou bien un particulier ? 
          Vous désirez avoir plus de visibilité ?
        </Paragraph>
        <Paragraph>
          Vous pouvez dès maintenant mettre en ligne votre exposition sur Start !
        </Paragraph>
        <CtaWrapper>
          <Cta to={proPath.compile()}>
            Découvrir
          </Cta>
        </CtaWrapper>
      </ProfessionalCard>
    </SectionContent>
  </Wrapper>
);


// WEBPACK FOOTER //
// src/app/src/components/SectionProfessional/SectionProfessional.tsx